import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../contexts/CartContext';
const mainDishes = [{
  id: 'main-1',
  name: 'Jerk Chicken',
  desc: 'Spicy, marinated grilled chicken with authentic Caribbean flavors.',
  price: '$15.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/download-3-scaled.jpg?fit=1920%2C1280&ssl=1',
  emoji: '🍗'
}, {
  id: 'main-2',
  name: 'Peanut Butter Soup',
  desc: 'Creamy, savory peanut soup cooked with assorted meats and spices.',
  price: '$15.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/Panut-Butter-Soup-12.99.jpeg?fit=714%2C883&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-3',
  name: 'Curry Chicken',
  desc: 'Tender chicken pieces simmered in a rich, aromatic curry sauce.',
  price: '$15.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/WhatsApp-Image-2022-05-30-at-5.01.59-AM.jpeg?fit=1024%2C683&ssl=1',
  emoji: '🍗'
}, {
  id: 'main-4',
  name: 'Jollof Rice with Meat & Plantain',
  desc: 'Classic West African seasoned rice served with tender meat and sweet plantains.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/jollog-rice.jpg?fit=1024%2C683&ssl=1',
  emoji: '🍛'
}, {
  id: 'main-5',
  name: 'Pepper Soup with White Rice',
  desc: 'Spicy, aromatic broth with tender meat, served with a side of white rice.',
  price: '$13.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2021/04/WhatsApp-Image-2022-05-30-at-5.01.57-AM-6.jpeg?fit=1024%2C683&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-6',
  name: 'Fried Rice with Plantain',
  desc: 'Flavorful fried rice mixed with vegetables, served with sweet fried plantains.',
  price: '$17.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/fried-rice.jpg?fit=1024%2C683&ssl=1',
  emoji: '🍛'
}, {
  id: 'main-7',
  name: 'Cassava Leaves',
  desc: 'Traditional stew made from ground cassava leaves, palm oil, and meats.',
  price: '$15.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/white-rice-veg-plant-e1658914511427.jpg?fit=1024%2C683&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-8',
  name: 'Yam Porridge with Stew Meat',
  desc: 'Soft yam chunks cooked in a flavorful palm oil broth with spinach and meat.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/yam-porridge.jpg?fit=1024%2C683&ssl=1',
  emoji: '🍠'
}, {
  id: 'main-9',
  name: 'Bucker Stew with White Rice & Plantain',
  desc: 'Hearty traditional stew served over steamed white rice with plantains.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/download-scaled.jpg?fit=1920%2C1280&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-10',
  name: 'Beans Porridge with Plantain & Meat',
  desc: 'Slow-cooked honey beans in palm oil sauce, served with plantain and meat.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/Beans-Plantain.jpeg?fit=116%2C87&ssl=1',
  emoji: '🫘'
}, {
  id: 'main-11',
  name: 'Egusi with Swallow',
  desc: 'Rich melon seed soup cooked with spinach and assorted meats, served with your choice of swallow.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/egusi-n-swallow.jpg?fit=1024%2C683&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-12',
  name: 'White Rice and Stew',
  desc: 'Steamed white rice served with rich, flavorful tomato stew.',
  price: '$15.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2021/04/meals-010.jpg?fit=1024%2C640&ssl=1',
  emoji: '🍛'
}, {
  id: 'main-13',
  name: 'Swallow with Ogbono Soup',
  desc: 'Draw soup made from ground ogbono seeds, served with your choice of swallow.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/photo-c.png?fit=1920%2C1536&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-14',
  name: 'Swallow with Ila Asepo',
  desc: 'Mixed okra soup cooked with palm oil and assorted meats, served with swallow.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2021/05/Copy-of-photo-c-e1655310856857.png?fit=1920%2C1536&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-15',
  name: 'Swallow with White Soup (SPECIAL)',
  desc: 'Traditional white soup made with utazi leaves and assorted meats, served with swallow.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/05/white-soup-n-amala.jpeg?fit=709%2C729&ssl=1',
  emoji: '🥘'
}, {
  id: 'main-16',
  name: 'Fried Fish with Jollof Rice',
  desc: 'Crispy fried whole fish served alongside our signature smoky jollof rice.',
  price: '$18.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/fried-fish-jollof.jpg?fit=640%2C640&ssl=1',
  emoji: '🐟'
}, {
  id: 'main-17',
  name: 'Grilled Chicken Drumsticks',
  desc: 'Juicy, seasoned chicken drumsticks grilled to golden perfection with a smoky West African spice rub.',
  price: '$16.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/chicken-laps.jpg?fit=1024%2C683&ssl=1',
  emoji: '🍗'
}];
interface MainDishesPageProps {
  onNavigate: (page: string) => void;
}
export function MainDishesPage({
  onNavigate
}: MainDishesPageProps) {
  const {
    addToCart
  } = useCart();
  const [addedId, setAddedId] = useState<string | null>(null);
  const handleAdd = (item: any) => {
    addToCart({
      id: item.id,
      name: item.name,
      price: parseFloat(item.price.replace('$', '')),
      emoji: item.emoji,
      image: item.image
    });
    setAddedId(item.id);
    setTimeout(() => setAddedId(null), 1200);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen bg-cream pb-20" data-id="element-552">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-553">
        <button onClick={() => onNavigate('menu')} className="mb-8 font-heading text-charcoal/60 hover:text-charcoal uppercase tracking-wider transition-colors" data-id="element-554">
          ← Back to Full Menu
        </button>

        <h1 className="font-heading text-5xl md:text-6xl text-charcoal uppercase tracking-wide mb-4 text-center" data-id="element-555">
          Main <span className="text-victory-red" data-id="element-556">Dishes</span>
        </h1>
        <p className="text-center font-body text-charcoal/70 max-w-2xl mx-auto mb-12" data-id="element-557">
          Authentic West African meals prepared with fresh, organic ingredients
          and traditional recipes.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-558">
          {mainDishes.map((item, i) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.05
        }} className="bg-white rounded-2xl p-6 shadow-lg border border-amber/10 flex flex-col group" data-id="element-559">
              <div className="h-48 bg-cream rounded-xl flex items-center justify-center mb-6 overflow-hidden" data-id="element-560">
                {item.image ? <img src={item.image} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-561" /> : <span className="text-5xl drop-shadow-md" data-id="element-562">{item.emoji}</span>}
              </div>
              <h3 className="font-heading text-2xl uppercase text-charcoal mb-2 leading-tight" data-id="element-563">
                {item.name}
              </h3>
              <p className="font-body text-charcoal/60 mb-6 flex-grow text-sm" data-id="element-564">
                {item.desc}
              </p>
              <div className="flex justify-between items-center mt-auto pt-4 border-t border-charcoal/5" data-id="element-565">
                <span className="font-heading text-3xl text-victory-red" data-id="element-566">
                  {item.price}
                </span>
                <button onClick={() => handleAdd(item)} className={`px-4 py-2 rounded-lg font-heading uppercase text-sm transition-colors active:scale-95 ${addedId === item.id ? 'bg-green-600 text-white' : 'bg-charcoal text-white hover:bg-amber'}`} data-id="element-567">
                  {addedId === item.id ? 'Added ✓' : 'Add to Order'}
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}